import React from 'react';

export default function () {
  return <script type="text/html" id="tmpl-mkl-pc-configurator-empty-viewer">
    Please select a variation to configure
  </script>
}
